import { useEffect, useRef } from 'react';

/**
 * Access the previous value of a given value. Tracked via ref, the value is
 * `null` until after the first render.
 *
 * Useful for comparing a prop value to its previous value during a render.
 */
export function usePrevious<T>(value: T) {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    ref.current = value;
    return () => {
      ref.current = null;
    };
  }, [value]);

  return ref.current;
}
